<!-- 欢迎区域 -->
<template>
  <div class="head">
    <div class="head-left">
      <div class="head-hi">
        <div class="hi-area">
          <img class="hi-bg" src="@/assets/images/hi-bg.png" alt="" />
          <div class="hi-text">Hi</div>
          <div class="hi-time">{{ getGreeting() }}，</div>
        </div>
        <div class="user-name">{{ userInfo?.nickname || "用户" }}</div>
      </div>
      <div class="greeting">欢迎使用情绪调节智能系统~</div>
    </div>
    <div class="head-right" v-if="isShowRgt">
      <img class="robot-img" src="@/assets/images/robot-img.png" alt="" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "GreetingArea",
  components: {},
  props: {
    isShowRgt: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  created() {},
  mounted() {},
  methods: {
    getGreeting() {
      const now = new Date();
      const hour = now.getHours(); // 获取当前小时
      let greeting = "";
      if (hour >= 5 && hour < 12) {
        greeting = "上午好";
      } else if (hour >= 12 && hour < 18) {
        greeting = "下午好";
      } else {
        greeting = "晚上好";
      }
      return greeting;
    },
  },
};
</script>

<style scoped lang="scss">
.head {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  .head-left {
    box-sizing: border-box;
    padding-top: 13px;
  }
  .head-hi {
    display: flex;
    height: 28px;
    align-items: center;
    .hi-area {
      position: relative;
      height: 28px;
      background: #d5ebfd, linear-gradient(90deg, #ffffff 0%, #ffffff 100%);
      display: flex;
      align-items: center;
    }
    .hi-bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 112px;
      height: 100%;
      z-index: 1;
    }
    .hi-text {
      min-width: 51px;
      height: 28px;
      font-size: 24px;
      font-weight: bold;
      color: #4d6eff;
      text-align: center;
      vertical-align: middle;
      z-index: 10;
    }
    .hi-time,
    .user-name {
      font-size: 16px;
      font-weight: 400;
      color: $text-color;
      z-index: 10;
      white-space: nowrap;
    }
    .hi-time {
      margin-left: 6px;
    }
  }
  .greeting {
    margin-top: 10px;
    line-height: 19px;
    font-size: 14px;
    font-weight: 400;
    color: $text-color;
  }
}
.head-right {
  height: 103px;
  padding-top: 7px;
  padding-right: 6px;
  box-sizing: border-box;
  .robot-img {
    width: 83px;
    height: 96px;
    line-height: 0;
  }
}
</style>
